import { Extension } from '@tiptap/react';

/**
 * Keyboard shortcuts not already provided by Tiptap's built-in extensions.
 *
 * Tiptap already ships (via StarterKit / the mark extensions):
 *   Mod-b/i/u (bold/italic/underline), Mod-Shift-s (strikethrough),
 *   Mod-e (inline code), Mod-Shift-h (highlight),
 *   Mod-Shift-l/e/r/j (TextAlign), Tab/Shift-Tab (list indent via ListKeymap).
 *
 * This fills the legacy shortcuts-plugin gaps that have no built-in:
 *   - Mod-] / Mod-[  → indent / outdent the current list item
 *   - Mod-Shift-x    → strikethrough (legacy alias alongside Mod-Shift-s)
 */
export const EditorShortcuts = Extension.create({
  name: 'editorShortcuts',

  addKeyboardShortcuts() {
    return {
      'Mod-]': () => this.editor.commands.sinkListItem('listItem'),
      'Mod-[': () => this.editor.commands.liftListItem('listItem'),
      'Mod-Shift-x': () => this.editor.commands.toggleStrike(),
    };
  },
});
